export default "__VITE_ASSET__BNdOr3y$__"